import { Box, Typography } from "@material-ui/core";
import { InputAdornment, Stack, styled } from "@mui/material";
import { useRef } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";

import { primary } from "../../constants/theme";
import { MemoizedButton } from "../../SDK/button";
import CountDownTimer from "../../SDK/CountDownTimer/CountDownTimer";
import { MemoizedPhoneField } from "../../SDK/input/phoneInput";
import { checkError } from "../../SDK/utils/validationHelpers";
import { handleDownload } from "../../utils/fileDownloads";
import UseStoreForm from "./hook/useStoreForm";

const CustomStoreForm = styled(Box)(({ theme }) => ({
  height: "360px",
  padding: "40px",
  background: `linear-gradient(69.72deg, rgba(232, 52, 94, 0.76) 17.38%, rgba(73, 69, 153, 0.76) 98.94%)`,

  backgroundRepeat: "no-repeat",
  backgroundSize: "100%",
  width: "100%",

  ".input-box": {
    width: "25%",
    "& .Mui-error": {
      color: primary.white,
    },
    "& .MuiFormHelperText-root": {
      color: primary.white,
    },
  },

  ".input-box .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-formControl":
    {
      paddingRight: "0px",
      borderRadius: "100px",
      border: "1px solid rgba(255, 255, 255, 0.4)",
      background: primary.matPink,
      color: primary.black,
      fontWeight: "600",
    },

  "& .Mui-error": {
    color: primary.white,
  },
  "& .MuiFormHelperText-root": {
    color: primary.white,
  },
  ".turno-electric": {
    fontSize: "28px",
    lineHeight: "42px",
    fontWeight: "400",
    color: primary.white,
    // textTransform:'capitalize',
    ".electric": {
      color: primary.main,
    },
  },
  ".heading-about-turno": {
    fontSize: "48px",
    lineHeight: "64px",
    fontWeight: "700",
    color: primary.white,
    // textTransform: "capitalize",
    span: {
      color: primary.electricGreen, //"#00EE98",
    },
  },

  ".boxLayout": {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    flexDirection: "column",
    textAlign: "center",
  },

  ".turno-electric-info": {
    fontSize: "20px",
    paddingTop: "40px",

    fontWeight: "400",
    color: primary.white,
    // textTransform:'capitalize',
    ".electric": {
      color: primary.main,
    },
  },

  ".otp-buttons": {
    display: "block",
    border: "transparent",
    background: primary.white,
    boxShadaw: "0",
    padding: "13px",
    borderRadius: "8px",
    color: primary.mainGreen,
    borderRadius: "100px",
    "&:hover": {
      color: primary.main,
      background: primary.white,
    },
  },

  ".downloadPass": {
    width: "380px",
  },

  [theme.breakpoints.down("md")]: {
    //padding: "20%",
    height: "260px",
    padding: "20px",

    ".input-box": {
      width: "100%",
      //marginTop: "10px",
    },
    ".turno-electric": {
      fontSize: "18px",
      lineHeight: "27px",
      marginBottom: "12px",

      alignItems: "center",
    },
    ".heading-about-turno": {
      fontSize: "25px",
      lineHeight: "35px",
    },

    ".turno-electric-info": {
      fontSize: "14px",
      paddingTop: "12px",
      //paddingBottom: "8px",

      fontWeight: "400",
      color: primary.white,

      ".electric": {
        color: primary.main,
      },
    },

    ".downloadPass": {
      width: "300px",
    },
  },
}));

const StoreForm = () => {
  const { form, loading, displayForm } = UseStoreForm();

  const date = new Date();

  const targetRef = useRef();

  return (
    <CustomStoreForm>
      <Box className="boxLayout" id="book-ticket">
        <Typography variant="h2" className="heading-about-turno">
          Turno Multibrand Store
        </Typography>

        {/* <Typography variant="h2" className="turno-electric">
          OPENING IN BANGALORE
        </Typography> */}

        <Stack style={{ marginLeft: "24px", marginRight: "24px" }}>
          <CountDownTimer />
        </Stack>

        <Typography variant="h5" className="turno-electric-info">
          Be one of the first visitors and stand a chance to win a cashback of
          up to ₹ 5, 000/- on booking any gadi.
        </Typography>
        <form
          onSubmit={form.handleSubmit}
          className="form-schedule"
          style={{ display: displayForm }}
        >
          <Box
            style={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <MemoizedPhoneField
              // style={style}
              style={{
                border: "none !important",
                paddingTop: "20px",
                color: primary.mainText,
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography style={{ color: primary.white }}>
                      +91
                    </Typography>
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <MemoizedButton
                      className="otp-buttons"
                      type="submit"
                      content={"Get Visit Pass"}
                      loading={loading}
                      handleClick={(e) => {
                        form.handleSubmit(e);
                      }}
                    />
                  </InputAdornment>
                ),
              }}
              error={!!checkError("mobile", form)}
              helperText={form?.errors?.mobile}
              className="input-box"
              name="mobile"
              placeholder="Your Mobile"
              value={form?.values?.mobile}
              onChange={(e) => {
                if (
                  !isNaN(Number(e.target.value)) &&
                  e.target.value?.length <= 10 &&
                  form.handleChange
                ) {
                  form.handleChange(e);
                }
              }}
            />
          </Box>
        </form>

        <Box
          style={{
            padding: "10px",
            display: displayForm === "none" ? "block" : "none",
          }}
          onClick={() => {
            handleDownload(
              `https://res.cloudinary.com/dktco93px/image/upload/v1685085499/Vip_pass_invite_uhyggt.png`
            );
          }}
        >
          <a
            href="https://assets.turnoclub.com/vippass/vip_pass_invitee.png"
            download
          >
            <LazyLoadImage
              className="downloadPass"
              effect="opacity"
              src={`${process.env.NEXT_PUBLIC_CDN_LINK}Retail+Page/webp/vip_pass_download.webp`}
              alt="Monuments Animation"
            />
          </a>

          {/* <Link
          id="performance-range"
          ref={targetRef}
          target="_blank"
          href="./vip_pass.png"
          hrefLang={"en"}
          rel="noreferrer"
          underline="none"
          download
          onClick={() => {
            
            sendAnalytics("download_store_pass_clicked", {}, "en");
          }}
        >
          <LazyLoadImage
            className="downloadPass"
            effect="opacity"
            src={`${process.env.NEXT_PUBLIC_CDN_LINK}Retail+Page/webp/vip_pass_download.webp`}
            alt="Monuments Animation"
          /></Link> */}
        </Box>
      </Box>
    </CustomStoreForm>
  );
};
export default StoreForm;
